/**
 * @file: constants.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const kPersistentKeyPrefix = 'com.zhichetech.euler';
export const kInstallationId = `${kPersistentKeyPrefix}.installation_id`;
export const kSessionId = `${kPersistentKeyPrefix}.session_id`;
